<template>
    <div class="text-xs-center">
        <v-dialog
                fullscreen
                v-model="modal"
                width="500">
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{titleAction}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn @click="close()" dark icon>
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid grid-list-xl v-if="event !== 'remove'">
                        <v-layout align-center wrap>
                            <v-flex d-flex sm6 xs12>
                                <v-select
                                        :disabled="!Edit"
                                        :items="listCategories"
                                        :label="$t('select', {field : $t('parentCategory') })"
                                        v-model="category"
                                ></v-select>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-flex d-flex lg12 md12 sm12 v-if="event !=='remove'" xs12>
                        <v-tabs color="primary" fixed-tabs ref="tablanguage">
                            <v-tab
                                    :key="index + 100"
                                    v-for="(lang, index) in complexLanguage"
                            >
                                {{lang.name}}
                            </v-tab>
                            <v-tab-item
                                    :key="index + 200"
                                    v-for="(lang, index) in complexLanguage"
                            >
                                <v-container fluid grid-list-xl>
                                    <v-layout wrap>
                                        <v-flex d-flex lg12 md12 sm12 xs12>
                                            <IgTextField v-if="lang._id === '5bd9f3ee7fa5610014fed21e'"
                                                         :rules="[v => rules.vacio(v,'category')]"
                                                         :disabled="!Edit"
                                                         :status="dialog"
                                                         :label="$tc('category')"
                                                         v-model="lang.categoryName"
                                            ></IgTextField>
                                            <IgTextField v-else
                                                         :disabled="!Edit"
                                                         :status="dialog"
                                                         :label="$tc('category')"
                                                         v-model="lang.categoryName"
                                            ></IgTextField>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-tab-item>
                        </v-tabs>
                    </v-flex>
                    <v-flex d-flex lg12 md12 sm12 v-if="event ==='remove'" xs12>
                        <v-treeview :items="listItemExterno" open-all>
                        </v-treeview>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small @click="Reset()" color="warning"
                           v-if="event === 'create' || event === 'withparent' || event === 'update'">{{$t('reset')}}
                    </v-btn>
                    <v-btn small @click="sendUpdate()" color="secondary" v-if="event === 'update'">{{$t('update')}}</v-btn>
                    <v-btn small @click="sendCreate()" color="success"
                           v-if="event === 'create' || event === 'withparent'">
                        {{$t('create')}}
                    </v-btn>
                    <v-btn small @click="sendRemove()" color="error" v-if="event === 'remove'">{{$t('delete')}}</v-btn>
                    <v-btn small color="primary"
                           @click="close()"
                    >
                        {{$t('cancel')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import queueToast from '../../../helpers/queueToast'
import rules from '../../../helpers/rules'

export default {
  name: 'formGestion',
  mixins: [rules],
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    event: {
      type: String,
      required: true
    },
    itemExterno: {
      type: Object,
      required: false,
      default: () => {
      }
    }
  },
  data () {
    return {
      complexLanguage: [],
      category: '0',
      Edit: true
    }
  },
  watch: {
    itemExterno: function () {
      this.createComplexLanguage()
    },
    externalCategory: function () {
      this.createComplexLanguage()
    },
    event: function (val) {
      let me = this
      switch (val) {
        case 'create' :
          this.category = '0'
          this.createComplexLanguage()
          this.Edit = true
          break
        case 'update':
          this.Edit = true
          setTimeout(function () {
            me.category = me.externalCategory.parentCategory ? me.externalCategory.parentCategory : '0'
          }, 2000)
          break
        case 'remove':
          this.Edit = false
          this.category = '0'
          this.createComplexLanguage()
          break
        case 'withparent':
          this.Edit = true
          setTimeout(function () {
            me.category = me.externalCategory._id ? me.externalCategory._id : '0'
          }, 2000)
      }
    }
  },
  mounted () {
    this.createComplexLanguage()
  },
  computed: {
    ...mapState({
      languages: state => state.languages.listLanguages,
      externalCategory: state => state.categories.selected
    }),
    ...mapGetters({
      categories: 'categories/selectList'
    }),
    modal: {
      get () {
        return this.dialog
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    titleAction () {
      switch (this.event) {
        case 'create':
          return this.$t('newAModel', { field: this.$tc('category') })
        case 'remove':
          return this.$t('updateModel', { field: this.$tc('category') })
        case 'update':
          return this.$t('updateModel', { field: this.$tc('category') })
        case 'withparent':
          return this.$t('newCategoryWithParent')
      }
    },
    listCategories () {
      let result = []
      result[0] = {
        text: this.$t('none'),
        value: '0'
      }
      this.categories.forEach(item => result.push(item))
      return result
    },
    listItemExterno () {
      let list = []
      list.push(this.itemExterno)
      return list
    }
  },
  methods: {
    ...mapActions({
      setNew: 'categories/setNew',
      setUpdate: 'categories/setUpdate',
      setRemove: 'categories/setEliminate'
    }),
    createComplexLanguage () {
      this.complexLanguage = []
      let me = this
      this.languages.forEach(item => {
        item.categoryName = undefined
        me.complexLanguage.push(item)
      })
      if (this.event === 'update' || this.event === 'remove') {
        this.complexLanguage.forEach((item, index) => {
          if (me.externalCategory && me.externalCategory.name) {
            let name = me.externalCategory.name.find(element => element.langId === item._id)
            if (name) {
              me.complexLanguage[index].categoryName = name.text
            }
          }
        })
      }
    },
    validateBeforeSend () {
      let result = true
      let message = []
      this.complexLanguage.forEach(item => {
        if (item._id === '5bd9ebae37c431001498335d' || item._id === '5bd9f3ee7fa5610014fed21e') {
          if (!item.categoryName) {
            result = false
            message.push(this.$t('error.nameSpanish'))
          }
        }
      })
      return {
        result,
        message
      }
    },
    createCategory () {
      let name = []
      this.complexLanguage.forEach(item => {
        if (item.categoryName) {
          name.push({
            langId: item._id,
            text: item.categoryName
          })
        }
      })
      const parentCategory = this.category === '0' ? '' : this.category
      return {
        name,
        parentCategory
      }
    },
    Reset () {
      if (this.event !== 'remove') {
        this.$refs.tablanguage.internalLazyValue = 0
      }
      this.category = '0'
      this.createComplexLanguage()
    },
    close () {
      this.Reset()
      this.modal = false
    },
    sendCreate () {
      const error = this.validateBeforeSend()
      if (!error.result) {
        queueToast(error.message)
        return
      }
      this.setNew(this.createCategory()).finally(() => this.close())
    },
    sendRemove () {
      this.setRemove(this.itemExterno._id).finally(() => this.close())
    },
    sendUpdate () {
      const error = this.validateBeforeSend()
      if (!error.result) {
        queueToast(error.message)
        return
      }
      let category = this.createCategory()
      category._id = this.externalCategory._id
      this.setUpdate(category).finally(() => this.close())
    }
  }
}
</script>
